import { useEffect, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';

import { getValidScopes } from '../../../../services/scope.service';
import { UserScopeSelector } from '../appuser/UserScopeSelector';

import TemplateScopeSelector from './templatescopeselector';

// Styles
import '../../../../styles/muiTabs.scss';
interface ScopeProps {
  targetId: string;
  targetType: 'user' | 'template';
  isReadOnly: boolean;
}

const ScopeView = (props: ScopeProps) => {
  const [activeTab, setActiveTab] = useState<string>('0');
  const [scopes, setScopes] = useState<string[]>();

  useEffect(() => {
    getValidScopes().then((x) => {
      if (x.status == 200) {
        setScopes(x.data);
      }
    });
  }, []);

  return (
    <>
      <TabContext value={activeTab}>
        <div className='app-tabs'>
          <TabList onChange={(e, value) => setActiveTab(value)} TabIndicatorProps={{ style: { backgroundColor: '#808080' } }}>
            {scopes?.map((x, idx) => (
              <Tab key={idx} label={x} value={`${idx}`} sx={{ textTransform: 'none' }} style={{ color: '#808080', fontSize: '0.8em' }} />
            ))}
          </TabList>
        </div>
        {scopes?.map((x, idx) => (
          <TabPanel value={`${idx}`} key={idx}>
            {props.targetType === 'user' && <UserScopeSelector appUserId={props.targetId} scopeName={x} />}
            {props.targetType === 'template' && <TemplateScopeSelector templateId={props.targetId} scopeName={x} />}
          </TabPanel>
        ))}
      </TabContext>
    </>
  );
};

export default ScopeView;
